import { render, staticRenderFns } from "./table.html?vue&type=template&id=760aeb81&scoped=true&"
import script from "./table.js?vue&type=script&lang=js&"
export * from "./table.js?vue&type=script&lang=js&"
import style0 from "./table.scss?vue&type=style&index=0&id=760aeb81&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "760aeb81",
  null
  
)

export default component.exports